import { useTranslation } from 'react-i18next';

export const Copyright = () => {
  const { t } = useTranslation();

  return (
    <div className="text-sm text-gray-600">
      { t( 'common:copyright' ) }
    </div>
  );
};